import { create } from 'zustand';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { ProjectCategory } from '@/features/projects/shared/types/category';

export type AcceptSubprojectInvitationStep =
  | 'info'
  | 'category'
  | 'subcategory'
  | 'budgets'
  | 'inviteMembersInput'
  | 'inviteMembersOverview';

interface AcceptSubprojectInvitationStoreData {
  step: AcceptSubprojectInvitationStep;
  orgId?: number;
  subprojectName?: string;
  subprojectDescription?: string;
  contactPerson?: string;
  selectedCategory?: ProjectCategory;
  selectedSubcategory?: ProjectCategory;
  kpiBudgets?: Record<number, number | null>; // kpiId -> budget amount
  invitedMembers?: OrgMemberWithProfile[];
}

interface AcceptSubprojectInvitationStore {
  data: AcceptSubprojectInvitationStoreData;
  setData: (data: Partial<AcceptSubprojectInvitationStoreData>) => void;
  reset: () => void;
}

const initialData: AcceptSubprojectInvitationStoreData = {
  step: 'info',
  orgId: undefined,
  subprojectName: undefined,
  subprojectDescription: undefined,
  contactPerson: undefined,
  selectedCategory: undefined,
  selectedSubcategory: undefined,
  kpiBudgets: undefined,
  invitedMembers: [],
};

export const useAcceptSubprojectInvitationStore =
  create<AcceptSubprojectInvitationStore>((set) => ({
    data: initialData,
    setData: (newData) =>
      set((state) => ({
        data: {
          ...state.data,
          ...newData,
        },
      })),
    reset: () =>
      set({
        data: initialData,
      }),
  }));

export const getAcceptSubprojectInvitationStepIndex = (
  step: AcceptSubprojectInvitationStep,
): number => {
  switch (step) {
    case 'info':
      return 0;
    case 'category':
      return 1;
    case 'subcategory':
      return 1;
    case 'budgets':
      return 2;
    case 'inviteMembersInput':
      return 3;
    case 'inviteMembersOverview':
      return 3;
  }
};
